import React from "react";
import Heading from "../../common/heading/Heading";
import "./Hero.css";

const Hero = () => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <div className="row">
            <Heading
              subtitle="WELCOME TO ZENTRIX"
              title="Best Online Education Expertise"
            />

            <p>
              Unleash the power of modern web development as you learn to build
              dynamic, scalable applications from start to finish. Our expert
              instructors will guide you through every step of the journey, from
              setting up your development environment to deploying your projects
              with confidence.
            </p>
          </div>
        </div>
      </section>
      <div className="margin"></div>
    </>
  );
};

export default Hero;
